import { useContextMenuStore } from '@/modules/contextMenu/useContextMenuStore';
import { IContextMenuService } from './IContextMenuService';
import { ContextMenuServiceImpl } from './ContextMenuServiceImpl';
import { ContextMenuServiceExceptionDecorator } from './ContextMenuServiceExceptionDecorator';
import { ContextMenuServiceLogDecorator } from './ContextMenuServiceLogDecorator';

export class ContextMenuServiceFactory {
  private static instance: ContextMenuServiceFactory | null = null;
  private contextMenuStore: typeof useContextMenuStore;

  public static initialize(contextMenuStore: typeof useContextMenuStore) {
    ContextMenuServiceFactory.instance = new ContextMenuServiceFactory(contextMenuStore);
  }

  public static getInstance() {
    if (ContextMenuServiceFactory.instance === null) {
      throw new Error(
        'ContextMenuServiceFactory not yet initialized. Call ContextMenuServiceFactory.initialize() first.',
      );
    }
    return ContextMenuServiceFactory.instance;
  }

  private constructor(contextMenuStore: typeof useContextMenuStore) {
    this.contextMenuStore = contextMenuStore;
  }

  public createContextMenuService(): IContextMenuService {
    let result: IContextMenuService = this.makeContextMenuService();

    result = new ContextMenuServiceExceptionDecorator(result);
    result = new ContextMenuServiceLogDecorator(result);

    return result;
  }

  private makeContextMenuService(): IContextMenuService {
    return new ContextMenuServiceImpl(this.contextMenuStore);
  }
}
